import React from "react";

/**
 * @component ArrowDownSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ArrowDownSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ArrowDownSmallIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={16}
      height={16}
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ArrowDownSmallIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.248 6.843a.662.662 0 01.9 0 .578.578 0 010 .85L8 10.666 4.853 7.692a.578.578 0 010-.85.662.662 0 01.9 0L8 8.968l2.248-2.124z"
      />
    </svg>
  )
);
ArrowDownSmallIcon.displayName = "ArrowDownSmallIcon";
export default ArrowDownSmallIcon;
